import React from 'react';
import { useQuery } from '@apollo/client/react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  GetTasksForContractQuery,
  GetTasksForContractQueryVariables,
  GetTasksForContractDocument,
  GetRecurringTasksForContractQuery,
  GetRecurringTasksForContractQueryVariables,
  GetRecurringTasksForContractDocument,
} from '../../../generated/graphql';

import { ContractTasksList } from './contract-tasks-list';
import { ContractRecurringTasksList } from './contract-recurring-tasks-list';

interface RelatedTasksSectionProps {
  contractId: string;
  disabled?: boolean;
  tabValue: string;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`invoices-tabpanel-${index}`}
      aria-labelledby={`invoices-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export function RelatedTasksSection({ contractId, disabled, tabValue, onTabChange }: RelatedTasksSectionProps) {
  const { data: tasksData, refetch: refetchTasks } = useQuery<
    GetTasksForContractQuery,
    GetTasksForContractQueryVariables
  >(GetTasksForContractDocument, {
    variables: { contractId },
  });

  const { data: recurringTasksData, refetch: refetchRecurringTasks } = useQuery<
    GetRecurringTasksForContractQuery,
    GetRecurringTasksForContractQueryVariables
  >(GetRecurringTasksForContractDocument, {
    variables: { contractId },
  });

  const tasks = tasksData?.getTasksForContract || [];
  const recurringTasks = recurringTasksData?.getRecurringTasksForContract || [];

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={onTabChange} aria-label="tasks tabs">
          <Tab label="Úlohy" id="reldocs-tab-2" aria-controls="reldocs-tabpanel-2" value="tasks" />
          <Tab label="Pravidelné úlohy" id="reldocs-tab-3" aria-controls="reldocs-tabpanel-3" value="recurring" />
        </Tabs>
      </Box>

      <TabPanel index="tasks" value={tabValue}>
        <ContractTasksList contractId={contractId} tasks={tasks} onRefresh={() => refetchTasks()} disabled={disabled} />
      </TabPanel>
      <TabPanel index="recurring" value={tabValue}>
        <ContractRecurringTasksList
          contractId={contractId}
          tasks={recurringTasks}
          onRefresh={() => refetchRecurringTasks()}
          disabled={disabled}
        />
      </TabPanel>
    </Box>
  );
}
